import { checkParams, zeroUnit, soFarDate, ageCalc } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'
import { hasValue } from '../../utils/order'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (
		this.isMotion ||
		this.isNewMotion ||
		this.isResurvey ||
		this.isSimpleVisit
	) {
		return false
	}
	if (!this.isPAIC) {
		if (this.isAccidentInsurance || this.isHealthInsurance) {
			return false
		}
	}
	if (!injured) {
		return false
	}

	let list = [{ dependType: '04' }],
		tempSubMap = {}
	if (injured.familyDto && injured.familyDto.familyInfoList.length) {
		list = injured.familyDto.familyInfoList
	}
	for (const item of list) {
		let row = []
		let canEmpty = false // 是否为非必填
		if (['04', '05'].includes(item.dependType)) {
			// 父母
			if (hasValue(item.age)) {
				canEmpty = item.age < 58
			}
			if (hasValue(item.birthday)) {
				canEmpty = ageCalc(item.birthday) < 58
			}
		} else if (item.dependType === '06') {
			// 子女
			if (hasValue(item.age)) {
				canEmpty = item.age > 18
			}
			if (hasValue(item.birthday)) {
				canEmpty = ageCalc(item.birthday) > 18
			}
		}

		// 其它扶养人
		if (item.dependType === '03') {
			row.push({
				label: '与伤者关系',
				value: item.fosterRelation,
			})
		}
		row.push({
			label: '姓名',
			value: canEmpty && !hasValue(item.name) ? '未获取到' : item.name,
		})
		let isPAIC = this.isPAIC && this.isFirstVisit
		if (isPAIC) {
			row.push({
				label: '出生日期',
				value: soFarDate(item.birthday),
			})
		} else {
			row.push({
				label: '年龄',
				value: zeroUnit(item.age, '岁'),
			})
		}

		// 其它扶养人、伤者子女、伤者配偶
		if (['03', '06', '07'].includes(item.dependType)) {
			row.push({
				label: '性别',
				value: setting.sexMap[item.sex],
			})
		}
		row.push({
			label: '户籍状态',
			value:
				canEmpty && !hasValue(item.censusRegisterType)
					? '未获取到'
					: setting.censusRegisterTypeMap[item.censusRegisterType],
		})
		if (!isPAIC) {
			row.push({
				label: '常住地址',
				value:
					canEmpty && !hasValue(item.formatAddress)
						? '未获取到'
						: item.formatAddress,
			})
		}
		// 伤者父亲、伤者母亲
		if (['04', '05'].includes(item.dependType)) {
			row.push({
				label: '生育子女数',
				value:
					canEmpty && !hasValue(item.dependCount)
						? '未获取到'
						: item.dependCount,
			})
		}
		// 其它扶养人
		if (item.dependType === '03') {
			row.push({
				label: '情况说明',
				value: item.remark,
			})
		} else {
			row.push({
				label: '备注（非必填）',
				value: item.remark,
			})
		}
		if (!tempSubMap[item.dependType]) {
			tempSubMap[item.dependType] = []
		}
		tempSubMap[item.dependType].push(row)
	}

	function showItem(str) {
		return ['1'].includes(str)
	}

	const orderNum = ['04', '05', '07', '06', '03'],
		subList = [],
		familyDto = injured.familyDto || {}
	const descMap = {
			'04': '已身故',
			'05': '已身故',
			'07': setting.partnerStatusMap[familyDto.partnerStatus],
			'06': '无子女',
			'03': '无其他家庭成员',
		},
		emptyMap = {
			'04': showItem(familyDto.fatherDied),
			'05': showItem(familyDto.motherDied),
			'07': ['0', '1', '2'].includes(familyDto.partnerStatus),
			'06': showItem(familyDto.noChildren),
			'03': showItem(familyDto.noOther),
		}
	orderNum.forEach(item => {
		if (emptyMap[item] || (tempSubMap[item] && tempSubMap[item].length)) {
			if (['03', '06'].includes(item) && !emptyMap[item]) {
				tempSubMap[item].forEach((subItem, key) => {
					subList.push({
						title:
							setting.dependentTypeMap[item] +
							(tempSubMap[item].length > 1 ? key + 1 : ''),
						show: injured.familyDto ? !emptyMap[item] : true,
						emptyDesc: descMap[item],
						children: subItem,
					})
				})
			} else {
				subList.push({
					title: setting.dependentTypeMap[item],
					show: injured.familyDto ? !emptyMap[item] : true,
					emptyDesc: descMap[item],
					children: (tempSubMap[item] && tempSubMap[item][0]) || [],
				})
			}
		}
	})

	const obj = {
		title: '家庭成员信息',
		children: [],
		subList,
		// show: {
		// 	hasFamily,
		// },
	}
	return obj
}
